module.exports = "<span [ngClass]=\"{'selected': selected}\" [class]=\"'tag tag-' + tag.substr(0,1).toLowerCase()\">{{tag}}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/single-tag/single-tag.component.html
// module id = ./src/app/tags/single-tag/single-tag.component.html
// module chunks = main